import type { ReactElement } from "react";
import { Heading, LoadingAnimation } from "@knowtex-ai/components";

export interface PatientSessionHeaderProps {
  patientName: string | null;
  identifier: string | null;
  isEnriching: boolean;
}

export default function PatientSessionHeader({
  patientName,
  identifier,
  isEnriching,
}: PatientSessionHeaderProps): ReactElement {
  return (
    <div className="w-full text-center mb-6 mt-2">
      <Heading
        as="h1"
        size="large"
        className="text-3xl md:text-4xl lg:text-5xl text-dark-purple mb-2 break-words"
      >
        {patientName || "Loading..."}
      </Heading>

      <div className="min-h-[2rem] flex items-center justify-center">
        {isEnriching ? (
          <LoadingAnimation aria-label="Updating patient context" />
        ) : (
          <Heading as="h2" size="small" className="text-xl text-accent1">
            {identifier ? `${identifier}` : ""}
          </Heading>
        )}
      </div>
    </div>
  );
}
